module.exports = __webpack_public_path__ + "img/Shiba-BG1.aa84a304.jpg";